import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CuentaPage from "../pages/cuenta/page";
import PrivacidadPage from "../pages/privacidad/page";
import TerminosPage from "../pages/terminos/page";
import BienvenidaPage from "../pages/bienvenida/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboardPage from "../pages/admin/dashboard/page";
import AdminResetPasswordPage from "../pages/admin/reset-password/page";
import SobreNosotrosPage from "../pages/sobre-nosotros/page";
import BlogPage from "../pages/blog/page";
import BlogPostPage from "../pages/blog/post/page";
import RoadmapPage from "../pages/roadmap/page";
import CasosDeUsoPage from "../pages/casos-de-uso/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/bienvenida", element: <BienvenidaPage /> },
  { path: "/cuenta", element: <CuentaPage /> },
  { path: "/privacidad", element: <PrivacidadPage /> },
  { path: "/terminos", element: <TerminosPage /> },
  { path: "/sobre-nosotros", element: <SobreNosotrosPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <BlogPostPage /> },
  { path: "/roadmap", element: <RoadmapPage /> },
  { path: "/casos-de-uso", element: <CasosDeUsoPage /> },
  { path: "/admin", element: <AdminLoginPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin/dashboard", element: <AdminDashboardPage /> },
  { path: "/admin/reset-password", element: <AdminResetPasswordPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
